import React from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";

const StatsCards = ({ site, stats, fromDate, toDate }) => {
  const history = useHistory();

  const formatDate = (date) => moment(date).format("YYYY-MM-DD");

  const cards = [
    {
      title: "Total Enter Vehicle",
      value: stats?.totalEntries,
      icon: "pi pi-sign-in",
      key: "totalEnter",
      accent: "enter",
    },
    {
      title: "Total Parked",
      value: stats?.parked,
      icon: "pi pi-th-large",
      key: "totalParked",
      accent: "parked",
    },
    {
      title: "Total Exit",
      value: stats?.exit,
      icon: "pi pi-sign-out",
      key: "totalExit",
      accent: "exit",
    },
    {
      title: "Total Amount",
      value: stats?.revenue,
      icon: "pi pi-wallet",
      key: "totalAmount",
      accent: "amount",
    },
  ];

  const handleCardClick = (type) => {
    const baseUrl = window.location.origin;
    const query = `fromDate=${formatDate(fromDate)}&toDate=${formatDate(toDate)}&site=${site || ""}`;

    if (type === "totalAmount") {
      window.open(`${baseUrl}/#/DashboardCollectionReport?${query}`, "_blank");
    } else {
      window.open(`${baseUrl}/#/state-detail?type=${type}&${query}`, "_blank");
    }
  };

  return (
    <div className="formgrid grid">
      {cards.map((item, index) => (
        <div
          key={index}
          className="field col-12 md:col-3 cursor-pointer"
          onClick={() => handleCardClick(item.key)}
        >
          <div
            className={`dashboard-stat-card dashboard-stat-card--${item.accent} h-full`}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleCardClick(item.key);
              }
            }}
          >
            <div className="dashboard-stat-card__top">
              <div>
                <p className="dashboard-stat-card__label">{item.title}</p>
                <h3 className="dashboard-stat-card__value">{item.value}</h3>
              </div>
              <div className="dashboard-stat-card__icon-wrap" aria-hidden>
                <i className={item.icon} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
